import React from "react";
import get from "lodash/get";
import { StoryElement } from "@quintype/components";
import { Summary } from "../../atoms/summary";
import { QuoteElement } from "../../atoms/quote";
import { Blurb } from "../../atoms/blurb";
import { BlockQuote } from "../../atoms/block-quote";
import { BigFact } from "../../atoms/big-fact";
import { AlsoRead } from "../../atoms/also-read";
import { QuestionAnswer } from "../../atoms/question-answer";
import { ImageGallery } from "../../atoms/image-gallery";
import { VideoPlaylist } from "../../collection-templates/video-playlist";
import PropTypes from "prop-types";
import { ImageElement } from "../../atoms/image";
import atob from "atob";
import "./style.m.css";
import { EpisodePlayButton } from "../../molecules/episode-play-button";

const getJSEmbedElement = (element, index) => {
  const elementDecodedString = atob(element["embed-js"]);

  // Iframe has episode_id
  if (elementDecodedString.indexOf("episode_id") > -1) {
    const regex = /<iframe.*?src="(.*?)".*?<\/iframe>/;
    // https://player.acast.com/5ec3d9497cef7479d2ef4798/episodes/nl-hafta-ep282?episode_id=5ef7205983254875562d555f
    const match = regex.exec(elementDecodedString);
    const iframeSrc = match[1];

    const showId = iframeSrc.substring(
      iframeSrc.lastIndexOf("com/") + 4,
      iframeSrc.indexOf("/episode")
    );
    const episodeId = iframeSrc.substring(
      iframeSrc.lastIndexOf("episode_id=") + 11,
      iframeSrc.length
    );

    const obj = {
      show_id: showId,
      episode_id: episodeId
    };

    return (
      <div styleName="podcast-embed">
        <EpisodePlayButton data={obj} />
      </div>
    );
  }

  if (elementDecodedString.indexOf("embed.acast.com") > -1) {
    const regex = /<iframe.*?src="(.*?)".*?<\/iframe>/;
    const match = regex.exec(elementDecodedString);
    const iframeSrc = match[1].split("/");
    const showId = iframeSrc[3];
    const episodeId = iframeSrc[4] && iframeSrc[4].split("?")[0];

    const obj = {
      show_id: showId,
      episode_id: episodeId
    };

    if (episodeId) {
      return (
        <div styleName="podcast-embed">
          <EpisodePlayButton data={obj} />
        </div>
      );
    } else {
      return (
        <div styleName="podcast-embed">
          <StoryElement element={element} key={index}></StoryElement>
        </div>
      );
    }
  }

  return (
    <div styleName="podcast-embed">
      <StoryElement element={element} key={index}></StoryElement>
    </div>
  );
};

const renderVideoPlaylist = videoId => {
  return (
    <React.Fragment>
      <VideoPlaylist collection={null} youtubePlaylistId={videoId} />
    </React.Fragment>
  );
};

function StoryElements(props) {
  console.log(props);
  const story = get(props, ["story"], {});
  let count = 0;
  let video = null;

  if (props.card && props.card.metadata.attributes && props.card.metadata.attributes.youtubeplaylist) {
    video = props.card.metadata.attributes.youtubeplaylist[0];
  }

  function getElement(element, index, card) {
    const subType = element.subtype || element.type;
    if (subType === "also-read") {
      count++;
    }
    switch (subType) {
      case "summary":
        return <Summary element={element} key={index} />;
      case "jsembed":
        return getJSEmbedElement(element, index);
      case "quote":
        return <QuoteElement element={element} key={index} />;
      case "blockquote":
        return <BlockQuote element={element} key={index} />;
      case "blurb":
        return <Blurb element={element} key={index} />;
      case "bigfact":
        return <BigFact element={element} key={index} />;
      case "also-read":
        return (
          <AlsoRead story={story} element={element} key={index} count={count} />
        );
      case "question":
        return <QuestionAnswer element={element} key={index} type="question" />;
      case "answer":
        return <QuestionAnswer element={element} key={index} type="answer" />;
      case "q-and-a":
        return <QuestionAnswer element={element} key={index} type="q-and-a" />;
      case "image":
        return <ImageElement element={element} key={index} />;
      case "image-gallery":
        return (
          <ImageGallery
            element={element}
            key={index}
            story={story}
            card={card}
          />
        );
      default:
        if (video) {
          return (
            <>
              <StoryElement element={element} key={index} />
              {renderVideoPlaylist(video)}
            </>
          );
        }

        return <StoryElement element={element} key={index}></StoryElement>;
    }
  }

  const elements =
    props.card &&
    props.card["story-elements"].filter(
      element => element.id !== props.firstVideoElementID
    );

  return (
    <div className="story-card" styleName="story-card">
      {elements.map((element, index) => {
        return getElement(element, index, props.card, count);
      })}
      {/* {video && renderVideoPlaylist(video)} */}
    </div>
  );
}
StoryElements.propTypes = {
  card: PropTypes.shape({
    "story-elements": PropTypes.array
  }),
  firstVideoElementID: PropTypes.string
};

export const StoryCard = props => {
  return (
    <React.Fragment>
      <StoryElements {...props} />
    </React.Fragment>
  );
};
